import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminSettings.css';
import API_BASE_URL from '../../config';

const AdminSettings = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    // 🔥 LẤY ROLE
    const user = JSON.parse(localStorage.getItem('user'));
    let role = (user?.role || '').toLowerCase();

    if (typeof role === 'number') role = String(role);
    if (role === '1') role = 'admin';
    if (role === '2') role = 'user';
    if (role === '3') role = 'student';

    const isAdmin = role === 'admin';

    // 1. Fetch saved email
    useEffect(() => {
        const fetchEmail = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/api/settings/email`);
                if (res.data.setting_value) {
                    setEmail(res.data.setting_value);
                }
            } catch (err) {
                console.error("Error loading configuration:", err);
            }
        };
        fetchEmail();
    }, []);

    // 2. Save email
    const handleSave = async (e) => {
        e.preventDefault();

        // 🔥 CHẶN USER NGAY TẠI ĐÂY
        if (!isAdmin) return;

        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(
            `${API_BASE_URL}/api/settings/email`,
            { email },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
            alert(res.data.message || "Updated successfully!");
        } catch (err) {
            console.error("Error saving configuration:", err);
            alert("Failed to save email. Please check the server connection.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-page-container">
            <div className="admin-content-wrapper">
                <div className="page-header-section">
                    <h2 className="page-title">System Configuration 🛠️</h2>
                    <p className="page-subtitle">Manage application operational parameters</p>
                </div>

                <div className="admin-card-form">
                    <div className="settings-card-header">
                        <div className="icon-wrapper">📧</div>
                        <div>
                            <h3>Writing Submission Email Config</h3>
                            <p>This email will receive automated notifications when students submit new tasks.</p>
                        </div>
                    </div>

                    <form onSubmit={handleSave} className="settings-form-body">
                        <div className="form-group">
                            <label className="input-label">
                                Teacher's Email Address:
                                {!isAdmin && <span style={{ color: 'red', marginLeft: 8 }}>🚫</span>}
                            </label>

                            <input
                                type="email"
                                className="modern-input"
                                placeholder="e.g., teacher@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={!isAdmin} // 🔥 CHẶN EDIT
                                style={{
                                    cursor: !isAdmin ? 'not-allowed' : 'text',
                                    opacity: !isAdmin ? 0.6 : 1
                                }}
                            />
                        </div>

                        <div className="settings-action-footer">
                            <button 
                                type="submit" 
                                className="btn-submit-save" 
                                disabled={loading || !isAdmin} // 🔥 CHẶN BUTTON
                                style={{
                                    cursor: !isAdmin ? 'not-allowed' : 'pointer',
                                    opacity: !isAdmin ? 0.6 : 1
                                }}
                            >
                                {!isAdmin 
                                    ? "NO PERMISSION 🚫" 
                                    : (loading ? "Saving..." : "SAVE CHANGES ✨")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;